export default "/fonts/PublicSans-Thin.ttf?033ff65c5d16fad1f086801425ee1b51";